<template>
	<div class="wf-component wf-group-pois-menu">
		<ul class="wf-list" :style="getGroupColor(this.group)" :class="['wf-list-count-' + count] ">
			<li class="wf-list-item wf-list-header" :style="getGroupColor(this.group)" v-touch:tap="back()">{{ currentGroupName }} </li>
			<li class="wf-list-item" v-touch:tap="onClick(poi)" :class='{"wf-active": currentPOI && poi.id == currentPOI.id}' v-for="poi in getPOIs" :key='poi.id' v-html="poi.getName(language)"></li>
		</ul>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'GroupPOIsMenu',
	props: {
		group: {
			type: Object,
			default: null
		},
		currentPOI: {
			type: Object,
			default: null
		}
	},
	data () {
		return {
			count: 0
		}
	},
	computed: {
		...mapState('wf', ['language']),
		getPOIs() {
			if (this.group && this.group.pois) {
				let arr = this.group.pois.slice(0);
				arr = arr.filter(p => p.getShowInMenu());
				this.count = arr.length;
				return arr.sort((a, b) => {
					return a.getName(this.language).localeCompare(b.getName(this.language));
				});
			}
			else {
				return [];
			}
		},
		currentGroupName () {
			return this.group ? this.group.getName(this.language) : '';
		}
	},
	methods: {
		onClick (poi) {
			return () => {
				this.$emit('clicked', poi);
			};
		},
		back () {
			return () => {
				this.$emit('back');
			};
		},
		getGroupColor(group) {
			if (this.group) {
				return "background-color:" + this.group.getColor();
			}
		    return "";
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.wf-group-pois-menu {
		height: 47rem;
		overflow-x: hidden;
		overflow-y: auto;
		user-select: none;
		text-transform: uppercase;
		font-weight: 600;
		-ms-overflow-style: none;  /* IE and Edge */
  		scrollbar-width: none;  /* Firefox */
	}
	.wf-group-pois-menu::-webkit-scrollbar {
  		display: none;
	}

	.wf-group-pois-menu .wf-list {
		margin: 0;
		padding: 0;
	}

	.wf-group-pois-menu .wf-list-item {
		list-style: none;
		padding: 0;
		height: 6rem;
		font-size: 1.2rem;
		padding-left: 1.4rem;
		border-bottom: none;
		background-color: #e3e3e3;
	}

	.wf-group-pois-menu .wf-list-header{
		height: 8rem;
		font-size: 1.4rem;
		border-bottom: 3px solid #e3e3e3;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.wf-list-header h1 {
		margin-right: 2rem;
	}
</style>
